import React from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { TabBar } from '../../pages/sales/Sales.styles';

// Accesos rápidos de ventas. En teléfono el menú del encabezado está oculto,
// así que esta barra es la forma de moverse entre Vender / Mis ventas / Escáner.
// `mode`: 'empresa' (dueño) o 'staff' (operador).
const SalesNav = ({ mode }) => {
  const { pathname } = useLocation();
  const base = mode === 'staff' ? '/staff' : '/empresa';
  const items = [
    { to: `${base}/sales/new`, label: 'Vender' },
    { to: `${base}/sales`, label: mode === 'staff' ? 'Mis ventas' : 'Ventas' },
    { to: `${base}/scanner`, label: 'Escáner QR' },
  ];

  return (
    <TabBar aria-label="Ventas">
      {items.map((item) => (
        <Link
          key={item.to}
          to={item.to}
          aria-current={pathname === item.to ? 'page' : undefined}
        >
          {item.label}
        </Link>
      ))}
    </TabBar>
  );
};

export default SalesNav;
